// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__255AK","productName":"Table_productName__2kIpI"};